import React from "react";
import styles from "./VideoCard.module.scss";

const VideoCard = ({ videoUrl }: any) => {
  const getYouTubeEmbedUrl = (url: any) => {
    const regex =
      /(?:youtu\.be\/|youtube\.com\/(?:.*v=|embed\/|v\/|.+?\/))([^?&]+)/;
    const match = url.match(regex);
    return match ? `https://www.youtube.com/embed/${match[1]}` : "";
  };

  return (
    <div className={styles.VideoCardSizes}>
      {videoUrl ? (
        <iframe
          style={{ width: "400px", height: "300px" }}
          src={getYouTubeEmbedUrl(videoUrl)}
          title="YouTube video"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <p>Invalid video URL</p>
      )}
    </div>
  );
};

export default VideoCard;
